export default {
    "available_in_your_tariff": "Sizning tarifingizda mavjud",
    "market": "Bozor",
    "market_of_apps": "Ilovalar bozori",
    "most_popular_apps": "Eng mashhur ilovalar",
    "new_items": "Yangi narsalar",
    "recommended_apps": "Tavsiya etilgan ilovalar",
    "setup": "Sozlash",
    "submit_an_application": "Ariza yuborish",
    "your_application_was_submitted_our_manager_will_contact_you_soon": "Sizning arizangiz yuborildi, menejerimiz tez orada siz bilan bog'lanadi",
}
